import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {LayoutFullBleed} from "../../../../Components/Layout";
import {locations} from "../../../../Utilities/Location";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {ownCatalogApi} from "./ownCatalogApi";
import {ownApi} from "../ownApi";
import {OwnCatalogItem} from "./OwnCatalogItem";
import {SYSTEM_TYPES} from "../../libraryConstants";
import {getSystemTypeTextByValue} from "../../libraryUtility";
import { SearchResultsContainer } from "@/Components/SearchResults/SearchResultsContainer";

export const OwnCatalogWhatsNewContainer = ({
                                                handleApiCall,
                                                redirect,
                                            }: ContextProps) => {
    const [resources, setResources] = useState<Record<string, any>[]>([]);

    const handleEdit = (id: string) => {
        const path = locations.OWN_CATALOG_ITEM.getLink([id, SYSTEM_TYPES.Own]).to;
        redirect(path);
    }

    const handleAddToQueue = (id: string) => {
        handleApiCall(() => ownApi.addOwnQueueItem(id));
    };

    useEffect(() => {
        const getResources = () => {
            handleApiCall(() => ownCatalogApi.getWhatsNew(), (results: Record<string, any>[]) => setResources(results));
        }

        getResources();
    }, []);

    return <>
        <PageTitle h1={getSystemTypeTextByValue(SYSTEM_TYPES.Own.toString()) + " Library"}/>

        <SearchResultsContainer title="What's New">
    

            {
                resources.map((resource: Record<string, any>) => {
                    const handleClickEdit = () => handleEdit(resource.id);
                    const handleClickAddToQueue = () => handleAddToQueue(resource.id);
                    return <OwnCatalogItem
                        key={resource.id}
                        handleClickEdit={handleClickEdit}
                        handleClickAddToQueue={handleClickAddToQueue}
                        {...resource}
                    />;
                })
            }
            {
                isArrayNullOrEmpty(resources) &&
                <p className={`text-center`}>No results.</p>
            }

        </SearchResultsContainer>
   
    </>;
};
